import * as React from 'react';
import { useContext } from 'react';
import { ModalContext } from 'contexts/ModalContext';

import { Box, TextField, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import useAuth from 'hooks/useAuth';
import { validatePasswordChars } from 'utils';

export default function SetPasswordDialog() {
    const { requireSetPassword, setUserPassword, user } = useAuth();
    const [form, setForm] = React.useState({
        password: '',
        password2: ''
    });

    const [open, setOpen] = React.useState(requireSetPassword);
    const { setOpenConfirmationModal, setOpenInfoModal } = useContext(ModalContext);

    const handleClose = () => {
        setOpen(false);
    };
    const validateForm = () => {
        if (form?.password) {
            if (form?.password.length < 12) throw new Error('Password should be atleast 12 characters');
            if (form?.password !== form?.password2) throw new Error('Password did not match');
            if (!validatePasswordChars(form.password).status) {
                throw new Error(
                    'Password must include at least one lowercase letter, one uppercase letter, one number, and one special character.'
                );
            }
        }
    };

    const handleSubmit = async () => {
        // validate form
        try {
            validateForm();
        } catch (e) {
            setOpenInfoModal({
                isOpen: true,
                type: 'error',
                title: 'Error Occured',
                message: e.message
            });
            return false;
        }

        setOpenConfirmationModal({
            isOpen: true,
            message: `Are you sure you want to set your password?`,
            title: 'Confirmation',
            handleProceed: async () => {
                let passwordSet = false;

                try {
                    await setUserPassword(form.password, user?.assessmentId || '');
                    handleClose();
                    passwordSet = true;
                } catch (e) {
                    setOpenInfoModal({
                        isOpen: true,
                        type: 'error',
                        title: 'Error Occured',
                        message: e.message || `Error encountered while updating password`
                    });
                } finally {
                    setOpenConfirmationModal({
                        isOpen: false
                    });

                    if (passwordSet) {
                        setOpenInfoModal({
                            isOpen: true,
                            type: 'success',
                            title: 'Account Activated',
                            message: 'Your password has been saved and your account is now active. You can continue to the portal.',
                            actionLabel: 'CONTINUE'
                        });
                    }
                }
            }
        });
    };
    return (
        <React.Fragment>
            <Dialog open={open} aria-labelledby="set-password-title" aria-describedby="set-password-description">
                <DialogTitle id="set-password-title">
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>
                        <Box>
                            <Typography variant="h3" component="span" sx={{ fontWeight: 500 }}>
                                Create New Password
                            </Typography>
                            <Typography variant="subtitle2">Almost there! Just choose a new password</Typography>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        fullWidth
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        label="New Password"
                        margin="normal"
                        name="password"
                        type="password"
                        variant="outlined"
                    />
                    <TextField
                        fullWidth
                        label="Confirm Password"
                        onChange={(e) => setForm({ ...form, password2: e.target.value })}
                        margin="normal"
                        name="confirmPassword"
                        type="password"
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={handleSubmit} autoFocus>
                        SAVE PASSWORD
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
